import { render } from "./RiskPush.vue?vue&type=template&id=ca042098&scoped=true"
import script from "./RiskPush.vue?vue&type=script&lang=js"
export * from "./RiskPush.vue?vue&type=script&lang=js"

import "./RiskPush.vue?vue&type=style&index=0&id=ca042098&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca042098"]])

export default __exports__